<template>
  <div class="change">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="goback" size='0.4rem'/>
            <div class="search_con m_flex_box flex_vc">我要变更</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div>
      <img src="@/assets/img/changeAccessBG.jpg" alt="" style="width: 100%"/>
    </div>
    <div class="middle">
      <van-form @submit="onSubmit" validate-trigger="onSubmit">
        <h3>查询入网企业</h3>
        <van-field
          v-model="codeName"
          name="企业名称"
          label="企业名称"
          placeholder="请输入企业名称"
          maxlength="10"
        />
        <div style="width: 50%; margin: 0 auto; padding-top: 16px">
          <van-button round block type="small" native-type="submit" color="#007fff">
            查询
          </van-button>
        </div>
      </van-form>
      <!-- <h3></h3>
      <div class="searchName">
        <div class="name">企业名称:</div>
        <div class="entry">
          <input type="text" />
        </div>
      </div> -->
    </div>
    <div></div>
    <div class="tips">
      为了您顺利办理业务，请仔细阅读 <span @click="jumpChange">《变更须知》</span>,提前准备相应材料，了解业务办理流程
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "enterpriseAccess",
  data() {
    return {
      codeName: "",
    };
  },
  mounted() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    jumpChange() {
      this.$router.push({
        path: "/changeAccessInternet",
      });
    },
    onSubmit(values) {
      if (this.codeName == "") {
        this.$toast("企业名称必填");
      } else {
        this.$router.push({
          path: "/enterprisesList",
          query: {
            codeName: this.codeName,
          },
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.fixed_pad {
  padding-top: 1.1rem;
}
.fixed {
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  .top_normal {
    height: 100%;
    i {
      font-size: 0.32rem;
    }
  }
}
.top_header {
  height: 0.7rem;
  padding: 0.1rem 0rem;
  width: 7.04rem;
  margin: 0 auto;
  &.top_sm {
    padding: 0.1rem;
  }
  .search_con,
  .search_con_l {
    height: 0.7rem;
    box-sizing: border-box;
    font-size: 0.3rem;
    padding: 0 0.3rem;
    color: #303030;
    i {
      font-size: 0.36rem;
      margin-right: 0.2rem;
    }
  }
  input {
    width: 80%;
    height: 0.7rem;
    background-color: transparent;
  }
  .search_con {
    font-weight: bolder;
    justify-content: center;
    width: 5.78rem;
  }
  .search_con_l {
    width: 5.72rem;
  }
  .to_map {
    font-size: 0.28rem;
    img {
      margin-right: 0.06rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}
.change {
  min-height: 100vh;
  background-color: #ffffff;
  position: relative;
  .middle {
    h3 {
      font-weight: bold;
      font-size: 0.3rem;
      padding-left: 0.3rem;
      margin: 0.5rem 0;
    }
  }
  .searchName {
    height: 0.3rem;
    line-height: 0.3rem;
    display: flex;
    .name {
      padding-right: 0.5rem;
      text-align: right;
      flex: 1;
    }
    .entry {
      border: 1px solid #ccc;
      flex: 2;
    }
  }
  .tips {
    padding-top:3.5rem;
    text-align: center;
    width: 60%;
    margin: 0 auto;
    span {
      cursor: pointer;
      color: #ff0000;
    }
  }
}
</style>